// queries/useConsentUpdate.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getJwtToken, fetch } from "libs";
import { POST_UPDATE_CONSENTS } from "api";

export const useConsentUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      nsfwConsent,
      newsletterConsent,
      adultConsent,
    }: {
      nsfwConsent?: boolean;
      newsletterConsent: boolean;
      adultConsent: boolean;
    }) => {
      const response = await fetch(POST_UPDATE_CONSENTS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nsfw_consent: nsfwConsent,
          newsletter_consent: newsletterConsent,
          adult_consent: adultConsent,
        }),
      });

      return await response;
    },
    onSuccess: () => {
      console.log("Consent update successful");
      queryClient.invalidateQueries({ queryKey: ["useProfile", getJwtToken()] });
      queryClient.invalidateQueries({ queryKey: ["useModel"] });
      queryClient.invalidateQueries({ queryKey: ["forumGenerations"] });
      queryClient.invalidateQueries({ queryKey: ["generation"] });
    },
    onError: (error) => {
      console.error("Error in useUpdateConsents:", error);
    },
  });
};

export default useConsentUpdate;
